import React from 'react'
import styled, { withTheme } from 'styled-components'

import Divider from '../divider'
import Application from './Application'
import Avatar from './Avatar'
import LanguageTheme from './CompatibleLanguage'
import GlobalNavigation from './GlobalNavigation'
import Language from './Language'
import Theme from './Theme'

const Actions = styled.ul`
  list-style: none;
  display: inline-block;
  line-height: ${(props) => `${props.theme.headerHeight}px`};
  margin: 0 0 0 20px;
  .hasHeaderTabs & {
    margin: 0;
  }
  padding: 0;
  white-space: nowrap;

  .isInIframe & {
    display: none;
  }

  & > li {
    height: 100%;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    font-size: 20px;
    margin: 0 7.5px;
    color: ${(props) => `${props.theme.headerActionsColor}`};
    .large-size & {
      margin: 0 10px;
    }
    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
    }
    &:last-of-type {
      margin-right: 0;
    }
    .hasHeaderTabs & {
      color: #455064;
    }
    // 删除色系区分 统一色调
    // .hasHeaderTabs:not(.tnt-themeS1) & {
    //     color: rgba(255,255,255,.8);
    // }
    .hasHeaderTabs:not(.tnt-themeS1) & {
      color: #455064 !important;
    }
  }
`

export default withTheme((props) => {
  const {
    type,
    config: {
      theme = true,
      avatar = true,
      language = true,
      application = false,
      globalNavigation = false,
    } = {},
    theme: { compatible },
    userInfo = {},
    menus,
    apps,
    extraActions,
    headerRef,
    onLanguageChange,
    onThemeChange,
    onApplicationChange,
    onAppChange,
    onCollapseChange,
    onPersonalSetting,
    onChangePassword,
    onLogout,
    onLogoClick,
    AvatarCustom,
    ...rest
  } = props

  return (
    <Actions {...rest}>
      {extraActions}
      {globalNavigation && <GlobalNavigation headerRef={headerRef} menus={menus} />}
      {type !== 'enterprise' &&
        (!compatible ? (
          <>
            {language && <Language language={userInfo.lang} onChange={onLanguageChange} />}
            {theme && <Theme theme={userInfo.theme} onChange={onThemeChange} />}
          </>
        ) : (
          <LanguageTheme
            config={props.config}
            language={userInfo.lang}
            theme={userInfo.theme}
            onLanguageChange={onLanguageChange}
            onThemeChange={onThemeChange}
          />
        ))}
      {application && (
        <Application language={userInfo.lang} apps={apps} onChange={onApplicationChange} />
      )}
      {avatar && (
        <>
          <Divider type="vertical" />
          {AvatarCustom ? (
            <AvatarCustom
              userInfo={userInfo}
              onPersonalSetting={onPersonalSetting}
              onChangePassword={onChangePassword}
              onLogout={onLogout}
              onThemeChange={onThemeChange}
              config={{
                theme,
                language,
              }}
            />
          ) : (
            <Avatar
              userInfo={userInfo}
              onPersonalSetting={onPersonalSetting}
              onChangePassword={onChangePassword}
              onLogout={onLogout}
              onThemeChange={onThemeChange}
              config={{
                theme,
                language,
              }}
            />
          )}
        </>
      )}
    </Actions>
  )
})
